import { NgModule } from "@angular/core";
import { GenericModule } from "./generic/generic.module";
import { SharedModule } from "./shared/shared.module";
import { routing } from "./features.routing";

@NgModule({
    imports: [GenericModule, SharedModule.forRoot(), routing],
    declarations: [],
    exports: [GenericModule]
})
export class FeaturesModule {}
